<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-row>
          <v-col>
            <v-text-field
              v-model="email.address"
              autocomplete="off"
              :label="addressLabel"
              outlined
              :error-messages="getErrorMessages(v$.email.address)"
              @input="v$.email.address.$touch()"
              @blur="v$.email.address.$touch()"
            />
          </v-col>
          <v-col cols="auto">
            <v-checkbox
              v-model="email.no_email"
              label="None"
              class="mt-3"
              @input="v$.email.no_email.$touch()"
              @blur="v$.email.no_email.$touch()"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-text-field
          v-model="email.owner"
          autocomplete="off"
          label="Owner"
          outlined
          :error-messages="getErrorMessages(v$.email.owner)"
          @input="v$.email.owner.$touch()"
          @blur="v$.email.owner.$touch()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { email, helpers, requiredIf } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

export default {
  name: 'EmailFields',

  props: {
    required: {
      default: true,
      type: Boolean,
    },

    value: {
      default: _ => ({}),
      required: false,
      type: Object,
    },
  },

  setup () {
    return {
      v$: useVuelidate(),
    }
  },

  computed: {
    addressLabel () {
      if (this.email.no_email) return 'Email Address (None)'
      if (this.required) return 'Email Address *'
      return 'Email Address'
    },

    email: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },

  validations () {
    return {
      email: {
        address: {
          email: helpers.withMessage('Must be a valid email address', email),
          required: helpers.withMessage('Email is required, unless None is selected',
            requiredIf(this.isEmailRequired)),
        },

        no_email: {},
        owner: {},
      },
    }
  },

  watch: {
    'v$.email.$anyDirty' () { this.$emit('update:isDirty', this.v$.email.$anyDirty) },
    'v$.email.$invalid' () { this.$emit('update:isValid', this.v$.email.$invalid) },
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },

    isEmailRequired () {
      if (this.email.no_email) return false
      return this.required
    },
  },
}
</script>
